module.exports = __webpack_public_path__ + "static/media/blog-header.ca44111b.jpg";